import React from 'react';
import styled from '@emotion/styled';
import { Fade, Popper } from '@mui/material';
import type { FrameIndex } from '@/redux/slices/packagingSlice.types';
import { getSMPTETimecode } from '@/components/Packaging/utils';
import { useAppSelector } from '@/redux/hooks';
import { selectPackagingTimelineFrameRate } from '@/redux/selectors/packagingSelectors';

interface Props {
  isOpen: boolean;
  start: FrameIndex;
  end: FrameIndex;
  overlayElement: HTMLElement;
  placement: 'left' | 'right';
}

const StartEndIndicator: React.FC<Props> = ({ isOpen, overlayElement, start, end, placement }) => {
  const frameRate = useAppSelector(selectPackagingTimelineFrameRate);

  return (
    <Popper
      open={isOpen}
      anchorEl={overlayElement}
      placement={placement === 'left' ? 'top-start' : 'top-end'}
      transition
      style={{
        zIndex: 1 // to make sure StartEndIndicator overlaps OverlaysTray Tab component
      }}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={300}>
          <DropPosition>
            {getSMPTETimecode(start, frameRate)}
            {' – '}
            {getSMPTETimecode(end, frameRate)}
          </DropPosition>
        </Fade>
      )}
    </Popper>
  );
};

export default StartEndIndicator;

const BACKGROUND_COLOR = '#000000aa';
const DropPosition = styled.div`
  padding: ${({ theme }) => theme.spacing(0.4, 1)};
  background-color: ${BACKGROUND_COLOR};
  color: ${({ theme }) => theme.palette.getContrastText(BACKGROUND_COLOR)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  font-size: 0.75rem;
  white-space: nowrap;
  transform: translateY(-4px);
`;
